import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getSellerStamps } from '../../services/seller'
import { checkIfForeignDni } from '../../modules/utils/helpers'

export const GET_SELLER_STAMPS = 'GET_SELLER_STAMPS'
export const GET_SELLER_STAMPS_ERROR = 'GET_SELLER_STAMPS_ERROR'
export const GET_SELLER_STAMPS_SUCCESS = 'GET_SELLER_STAMPS_SUCCESS'
export const onGetSellerStamps = makeActionCreator(GET_SELLER_STAMPS)
export const onGetSellerStampsError = makeActionCreator(GET_SELLER_STAMPS_ERROR, 'payload')
export const onGetSellerStampsSuccess = makeActionCreator(GET_SELLER_STAMPS_SUCCESS, 'payload')
export const onGetSellerStampsThunk = payload => async dispatch => {
  dispatch(onGetSellerStamps())
  try {
    const { data } = await getSellerStamps({
      actionType: GET_SELLER_STAMPS,
      dni: payload.dni
    })

    const isForeign = checkIfForeignDni(payload.dni)

    const message = {
      3: 'Empresa liderada por mujeres',
      4: 'Empresa con jornadas laborales de 40 horas'
    }

    const getStamps = () => {
      const stampsList = data?.payload?.sellos ?? []
      return stampsList
        .filter(stamp => {
          if (isForeign && stamp.tipoSello === 3 && !stamp.forzado) {
            return false
          }
          return true
        })
        .map(stamp => ({
          name: stamp.valor,
          preSource: message[stamp.tipoSello] ?? '',
          source: stamp.fuente
        }))
    }

    return dispatch(onGetSellerStampsSuccess({ stamps: getStamps() }))
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetSellerStampsError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
